import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Image, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {useIntl} from 'react-intl'

const BundleProductRow = ({product, quantity = 1, showQuantity = false, showPrice = true}) => {
    const style = useMultiStyleConfig('Bundle')
    const intl = useIntl()
    const {currency: activeCurrency} = useCurrency()

    if (!product) {
        return null
    }
    const productName = product.c_variantIdentifier || product.productName || product.name || ''

    const productSubtitle = product.c_productSubtitle || product.c_marketingColour || ''

    const productPrice =
        quantity > 1 && product.basePrice
            ? Number(product.basePrice || 0)
            : Number(product.price || 0)
    const listPrice = intl.formatNumber(productPrice, {
        style: 'currency',
        currency: activeCurrency,
    })
    const swatchImage = product.imageGroups?.find((group) => group.viewType === 'swatch')
        ?.images?.[0]?.link
    const productImage =
        product.image || swatchImage || product.imageGroups?.[0]?.images?.[0]?.link || ''

    return (
        <Flex {...style.bundleProductRow}>
            <Flex {...style.bundleProductInfoContainer}>
                <Flex {...style.bundleProductImageContainer}>
                    {productImage && (
                        <Image src={productImage} alt={productName} {...style.bundleProductImage} />
                    )}
                </Flex>

                <Flex {...style.bundleProductInfo}>
                    <Text {...style.productName}>{productName}</Text>
                    {/* We can also add the colorswatch as we do in primary products in FlexibleBundle component. Remember that colorSwatch wants an array of enabledVariants and isBundle = true as props */}
                    {productSubtitle && <Text {...style.productSubtitle}>{productSubtitle}</Text>}
                </Flex>
            </Flex>

            {showPrice && (
                <Flex {...style.bundleProductPriceContainer}>
                    <Text {...style.bundleProductPrice}>
                        {showQuantity && quantity > 1 ? `${quantity}x ` : ''}
                        {listPrice}
                    </Text>
                </Flex>
            )}
        </Flex>
    )
}

BundleProductRow.propTypes = {
    product: PropTypes.object,
    quantity: PropTypes.number,
    showQuantity: PropTypes.bool,
    showPrice: PropTypes.bool,
}

export default BundleProductRow
